$(function () {
    $(".widget-modal a[data-btn=action]").on("click", function () {
        $(this).parents(".widget-modal").trigger(WidgetEvents.MODAL_ACTION_CLICKED);
    });

    $(".widget-modal").each(function (idx, element) {
        var formId = $(this).data("confirm-form-id");
        var _self = this;

        if (formId) {
            $("#" + formId).submit(function (e) {
                var confirmed = $(this).data("confirmed");

                if (!confirmed) {
                    e.preventDefault();
                    $(_self).modal('show');
                }
            });

            $(this).find(".btn[data-btn=action]").click(function () {
                $("#" + formId).data("confirmed", true);
                $("#" + formId).submit();
            });

            $(this).find(".btn[data-dismiss=modal]").click(function () {
                $("#" + formId)
                    .find("button[type=submit], input[type=submit]")
                    .removeClass("btn-loading")
                    .prop("disabled", false);
            });
        }


        $(document).on("shown.bs.modal", "#" + element.id, function () {
            var contentUrl = $(element).attr("data-content-url");

            if (contentUrl) {
                $.ajax({
                    method: "GET",
                    url: contentUrl,
                    success: function (d) {
                        $(element).find(".modal-body").html(d);
                    },
                    error: function (x, s, e) {

                    }
                })
            }
        })
    })
});